var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "send-email-box" }, [
    _c("span", { staticStyle: { "font-weight": "bold" } }, [
      _vm._v("\n    发送邮件至发起人：" + _vm._s(_vm.userName) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input_box" },
      [
        _c("span", { staticClass: "lable" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("Input", {
          staticClass: "ref_input",
          attrs: {
            type: "textarea",
            autosize: { minRows: 5, maxRows: 10 },
            placeholder: "请输入SAP或POS不能确认的原因",
          },
          model: {
            value: _vm.inputValue,
            callback: function ($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue",
          },
        }),
      ],
      1
    ),
    _vm._v("\n  附件：\n  "),
    _c("input", {
      ref: "fileInput",
      attrs: { type: "file" },
      on: { change: _vm.fileChange },
    }),
    _vm._v(" "),
    _c("button", { staticClass: "cancel-btn", on: { click: _vm.uploadFile } }, [
      _vm._v("确认上传"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pop-btn" },
      [
        _c("Button", { staticClass: "cancel-btn", on: { click: _vm.cancel } }, [
          _c("span", [_vm._v(_vm._s(_vm.chineseName.CANCEL))]),
        ]),
        _vm._v(" "),
        _c(
          "Button",
          {
            staticClass: "sav-btn",
            attrs: { type: "error" },
            on: { click: _vm.save },
          },
          [_c("span", [_vm._v(_vm._s(_vm.chineseName.CONFIRM))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }